import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Start from "@/pages/Start";
import Verify from "@/pages/Verify";
import Intake from "@/pages/Intake";
import Specification from "@/pages/Specification";
import Workspace from "@/pages/Workspace";
import Projects from "@/pages/Projects";
import ValidatedDemo from "@/pages/ValidatedDemo";
import Investor from "@/pages/Investor";
import Pilot from "@/pages/Pilot";
import Report from "@/pages/Report";
import AdminLogin from "@/pages/AdminLogin";
import AdminForgot from "@/pages/AdminForgot";
import AdminReset from "@/pages/AdminReset";
import AdminDashboard from "@/pages/AdminDashboard";
import AccountSignIn from "@/pages/AccountSignIn";
import AccountVerify from "@/pages/AccountVerify";
import ControlCenter from "@/pages/ControlCenter";
import TifControlCenter from "@/pages/TifControlCenter";
import { AuthProvider } from "@/lib/authContext";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <Toaster theme="dark" position="top-right" />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Landing />} />
          <Route path="/start" element={<Start />} />
          <Route path="/verify" element={<Verify />} />
          <Route path="/intake" element={<Intake />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/:id/specification" element={<Specification />} />
          <Route path="/projects/:id/workspace" element={<Workspace />} />
          <Route path="/projects/:id/report" element={<Report />} />
          <Route path="/validated-demo" element={<ValidatedDemo />} />
          <Route path="/investor" element={<Investor />} />
          <Route path="/pilot" element={<Pilot />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot" element={<AdminForgot />} />
          <Route path="/admin/reset" element={<AdminReset />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/control-center" element={<TifControlCenter />} />
          <Route path="/account/sign-in" element={<AccountSignIn />} />
          <Route path="/account/verify" element={<AccountVerify />} />
          <Route path="/control-center" element={<ControlCenter />} />
        </Route>
      </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
